import { Button } from 'flowbite-react';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../../Common/Loader';
import { useAppSelector } from '../../../Reducers/store';
import { HiPlus } from 'react-icons/hi';
import { Contact } from '../../../Models/Contact';
import ClientContactListTable from './ClientContactListTable';
import ClientContactModal from './ClientContactModal';
import ClientApi from '../../../Api/ClientApi';

export default function ClientContactList({ clientId }: { clientId: number }) {
  const { userModel } = useAppSelector((state) => state.user);
  const [contactListData, setcontactListData] = useState<Contact[]>([]);
  const [selectedContact, setSelectedContact] = useState<Contact | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);

  const getContacts = useCallback(() => {
    if (userModel) {
      try {
        setIsLoading(true);
        return ClientApi.getContactsForClient(clientId)
          .then((res) => {
            setcontactListData(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  }, [userModel]);

  useEffect(() => {
    getContacts();
  }, [getContacts]);

  const handleAddContactClick = () => {
    setSelectedContact(null);
    setShowModal(true);
  };

  const editContact = (location: Contact) => {
    setSelectedContact(location);
    setShowModal(true);
  };

  function deleteContact(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this?'
    );

    if (shouldRemove) {
      ClientApi.deleteContact(id)
        .then((res) => {
          if (res.data.success) {
            toast.success(res.data.message);
            getContacts();
          } else {
            toast.success('Error while deleting item');
          }
        })
        .catch((err) => {
          toast.error('Error: ' + err);
        });
    }
  }
  function checkAccess() {
    // if (userModel && userModel.userLevelId === UserLevelNames.SuperAdmin) {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className='w-full'>
        {checkAccess() && (
          <div className='w-full flex justify-end'>
            <Button onClick={handleAddContactClick} className='buttonMain'>
              <HiPlus size={20} />
            </Button>
          </div>
        )}
        <div className='w-full p-4'>
          <div className='relative'>
            {isLoading && <Loader />}
            <ClientContactListTable
              data={contactListData}
              deleteContact={deleteContact}
              editContact={editContact}
            />
          </div>
        </div>
      </div>
      <ClientContactModal
        show={showModal}
        setShow={setShowModal}
        clientId={clientId}
        getContacts={getContacts}
        selectedContact={selectedContact}
      />
    </>
  );
}
